module.exports = __webpack_public_path__ + "static/img/2.ea645c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20201015/2.png
// module id = N5Hf
// module chunks = 1